import { render, staticRenderFns } from "./SubmitTicketButtonGroupMobile.vue?vue&type=template&id=9b3b64c4&scoped=true&"
import script from "./SubmitTicketButtonGroupMobile.vue?vue&type=script&lang=ts&"
export * from "./SubmitTicketButtonGroupMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitTicketButtonGroupMobile.vue?vue&type=style&index=0&id=9b3b64c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b64c4",
  null
  
)

export default component.exports